export const apiCall = async(payload) =>{
  const auth = process.env.REACT_APP_AUTH_URL
  const livetracking = process.env.REACT_APP_PARTNER_BACKEND_URL
  const search = process.env.REACT_APP_SEARCH_URL
 
  if(window.location.host === "local.yolobus.in:4000"){
    payload.Authorization = process.env.REACT_APP_TOKEN
  }
  try {
      // const baseURl = `${payload.host === "auth" ?  auth : livetracking }`;
      const baseURl = (() => {
        switch (payload.host) {
          case "auth":
            return auth;
          case "search":
            return search;
          default:
            return livetracking;
        }
      })();
      const apiUrl = `${baseURl}${payload.endPoint}`;
      console.log("apiUrl" , apiUrl)
      
      const options = {
        method: payload.method,
        mode: 'cors',
        headers: {
          'platform': 'WEPA',
          'user-type': 'partner',
          'Content-Type': 'application/json',
          // 'credentials': 'include',
          ...(!payload.Authorization && {credentials:'include'}),
          ...(payload.Authorization && {Authorization:payload.Authorization}),
        },
        credentials :"include",
      };
      if (payload.method === 'POST') {
          options.body = JSON.stringify(payload.body);
      }
      
      const response = await fetch(apiUrl, options);
      return response.json();
    } catch (error) {
      return error
    } 
}

export const downloadApiCall = async(payload) =>{
const auth = process.env.REACT_APP_AUTH_URL
const livetracking = process.env.REACT_APP_PARTNER_BACKEND_URL

if(window.location.host === "local.yolobus.in:4000"){
  payload.Authorization = process.env.REACT_APP_TOKEN
}
try {
    const baseURl = `${payload.host === "auth" ?  auth : livetracking }`;
    const apiUrl = `${baseURl}${payload.endPoint}`;
    const options = {
      method: payload.method,
      mode: 'cors',
      headers: {
        'platform': 'WEPA',
        'user-type': 'partner',
        'Content-Type': 'application/json',
        // 'credentials': 'include',
        // ...(!payload.Authorization && {credentials:'include'}),       
        //  ...(payload.Authorization && { Authorization: payload.Authorization }),

        // ...(payload.Authorization && {Authorization:payload.Authorization}),
      },
      credentials :"include",
    };
    if (payload.method === 'POST') {
        options.body = JSON.stringify(payload.body);
    }
    
    const response = await fetch(apiUrl, options);
    return response;
  } catch (error) {
    return error
  } 
}

export const searchApiCall = async (payload) => {
  const auth = process.env.REACT_APP_AUTH_URL
  const livetracking = process.env.REACT_APP_PARTNER_BACKEND_URL
  const search = process.env.REACT_APP_SEARCH_URL

  try {
    const baseURl = (() => {
      switch (payload.host) {
        case "auth":
          return auth;
        case "search":
          return search;
        default:
          return livetracking;
      }
    })();

    const apiUrl = `${baseURl}${payload.endPoint}`;

    const options = {
      method: payload.method,
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        platform: "OPAP",
        "user-type": "opsapp",
        ...(payload.Authorization && { Authorization: payload.Authorization }),
      },
    };

    if ((payload.method === "PATCH" || payload.method === 'POST') && payload.body) {
      options.body = JSON.stringify(payload.body);
    }

    const response = await fetch(apiUrl, options);

    // Explicitly handle non-2xx HTTP responses
    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(
    //     errorData.errors[0].error.detail || `Something went wrong`
    //   );
    // }

    // Safely parse JSON
    const data = await response.json();
    // console.log("API Response Data: ", data);
    return data;
  } catch (error) {
    console.error("Error in API call:", error);
    throw new Error(error || "Network error occurred.");
  }
};